import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {InContextHelpMessage} from '@communityshare/ui-shared';
import useDialogLauncher from '@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import {DialogManager} from '@/dialogs_new/DialogManager';
import useIsProjectShareable from '@/features/share-project/hooks/useIsProjectShareable';

ProjectShareCallout.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      published: PropTypes.bool
    })
  }).isRequired
};

export default function ProjectShareCallout(props) {
  const {project} = props;
  const {t} = useTranslation();
  const launch = useDialogLauncher();
  const isShareable = useIsProjectShareable(project);

  if (!isShareable) {
    return null;
  }

  return (
    <InContextHelpMessage
      boldText={t('project_share.more_partners_bold')}
      bodyText={t('project_share.more_partners_body')}
      linkLabel={t('project_share.share_link')}
      onLinkClick={() => launch(DialogManager.ProjectShare.Config(project.id, 'manage'))}
    />
  );
}
